import { EMPTY_STRING } from "../constants/Dictionary";

export const calculateAverageWeighting = (
  data: { weighting: number; achievementPercent: number }[],
): string => {
  if (!data || data.length === 0 || data.some((item) => item.weighting === 0)) {
    return EMPTY_STRING;
  }

  const weights = data.map((g) => g.weighting / 100);
  const totalWeight = weights.reduce((sum, w) => sum + w, 0);
  const weightedSum = data.reduce(
    (sum, g, i) => sum + g.achievementPercent * weights[i],
    0,
  );

  const result = weightedSum / totalWeight;

  return `${Math.round(result)}%`;
};

export const getIntervalsByFive = (range: number[]) => {
  const min = Math.min(...range);
  const max = Math.max(...range);
  const roundMin = Math.ceil(min / 5) * 5;
  const roundMax = Math.floor(max / 5) * 5;

  return Array.from(
    { length: Math.floor((roundMax - roundMin) / 5) + 1 },
    (_, i) => roundMin + i * 5,
  );
};
